import React, { createContext, useState } from "react";

export const EditorContext = createContext({
  activeFormats: {},
  setFormats: () => {},
});

export const EditorProvider = ({ children }) => {
  const [activeFormats, setActiveFormats] = useState({
    common: {
      font: "Arial",
      color: "#000000",
      image: "",
    },
  });

  const setFormats = (data) => {
    setActiveFormats({ ...activeFormats, ...data });
  };

  return (
    <EditorContext.Provider
      value={{
        activeFormats,
        setFormats,
      }}
    >
      {children}
    </EditorContext.Provider>
  );
};
